import Immutable from 'immutable';
import moment from 'moment';
import { groupBy } from 'lodash';

const LOAD = 'farmInspection/LOAD';
const LOAD_SUCCESS = 'farmInspection/LOAD_SUCCESS';
const LOAD_FAIL = 'farmInspection/LOAD_FAIL';
const LOAD_DATA_SUCCESS = 'farmInspection/LOAD_DATA_SUCCESS';
const FARMIMPROVMENT_LOAD_ADD_SUCCESS = 'farmInspection/FARMIMPROVMENT_LOAD_ADD_SUCCESS';
const LEASESDATA_LOAD_SUCCESS = 'farmInspection/LEASESDATA_LOAD_SUCCESS';
const LEASESDATA_LOAD_FAIL = 'farmInspection/LEASES_LOAD_FAIL';
const INSPECTION_UPDATE_SUCCESS = 'farmInspection/INSPECTION_UPDATE_SUCCESS';
const FARM_INSPECTION_PRINT_SUCCESS = 'farmInspection/FARM_INSPECTION_PRINT_SUCCESS';
const FARM_IMP_INSP_LIST_SUCCESS = 'farmInspection/FARM_IMP_INSP_LIST_SUCCESS'

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  farmInspection: null,
  FarmImprovment: null,
  leaseData: null,
  data: {}
});

export default function reducer(state = initialState, action) {
  switch (action.type) {

    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('farmInspection', null);

    case LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('farmInspection', action.farmInspection);

    case LOAD_DATA_SUCCESS:
      return state
        .set('isLoad', false)
        .set('data', action.result)

    case FARMIMPROVMENT_LOAD_ADD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('FarmImprovment', action.result);

    case LEASESDATA_LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('leaseData', null);

    case LEASESDATA_LOAD_SUCCESS:
      return state
        .set('isLoad', false)
        .set('leaseData', action.leaseData);

    case FARM_INSPECTION_PRINT_SUCCESS:
      return state
        .set('isLoad', false)

    case INSPECTION_UPDATE_SUCCESS:
      return state
        .set('isLoad', false)

    case FARM_IMP_INSP_LIST_SUCCESS:
      return state
        .set('isLoad', false)
        .set('farmImpList', action.farmImpList);

    default:
      return state;
  }
}

export const getDataByFarmId = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/FarmInspectionTab/getData/' + id);
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    let inspectionData = [];
    if (res.farm_inspection_data.length > 0) {
      inspectionData = res.farm_inspection_data.map(item => {
        return Object.assign({}, item, {
          nextInspectionDate: item.nextInspectionDate ? moment.utc(item.nextInspectionDate).format('MM/DD/YYYY') : ''
        })
      })
    }

    const sortedInspections = inspectionData.sort((a, b) => {
      return moment(b.nextInspectionDate).year() - moment(a.nextInspectionDate).year()
    });
    let leaseData = [];
    if (res.farm_lease_data.length > 0) {
      res.farm_lease_data.forEach(lease => {
        lease.commences = lease.commences ? moment.utc(lease.commences).format('MM/DD/YYYY') : '';
        lease.expires = lease.expires ? moment.utc(lease.expires).format('MM/DD/YYYY') : '';
      });
      leaseData = groupBy(res.farm_lease_data, 'leaseType');
    }
    const result = Object.assign({}, res, {
      farm_inspection_data: sortedInspections,
      farm_lease_data: leaseData
    })
    dispatch({ type: LOAD_DATA_SUCCESS, result: { data: result } });
    return result;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const getLeaseDataByFarmId = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/FarmInspectionTab/getLeaseData/' + id);
    if (res.message) {
      dispatch({ type: LEASESDATA_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: LEASESDATA_LOAD_SUCCESS, leaseData: res });
    return res;
  } catch (error) {
    dispatch({ type: LEASESDATA_LOAD_FAIL, errorMessage: error });
  }
};

export const updateFarmInspection = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/FarmInspectionTab/farmInspection', { data });
    if (res.message) {
      dispatch({ type: LEASESDATA_LOAD_FAIL, errorMessage: res.message });
      return;
    }
    const inspection = getState().get('farmInspection').get('data');
    const inspectionList = inspection.data.farm_inspection_data;
    const leftInspections = inspectionList.filter((fi) => fi.id !== data.inspectionData.id);
    data.farm_inspection_data = Object.assign([], leftInspections);
    dispatch({ type: LOAD_DATA_SUCCESS, result: { data: Object.assign({}, data) } });

    return res;
  } catch (error) {
    dispatch({ type: LEASESDATA_LOAD_FAIL, errorMessage: error });
  }
};

export const addFarmInspection = (data) => async (dispatch, getState, api) => new Promise((resolve, reject) => {
  dispatch({ type: LOAD });
  try {
    let inspectionList = [];
    api.post('/FarmInspectionTab/farmInspection', { data })
      .then(async (res) => {
        if (res.message) {
          dispatch({ type: LOAD_FAIL, errorMessage: res.message });
          return;
        }
        const cropData = []
        for (let i = 0; i <= 4; i++) {
          cropData.push({ farm_inspection_data_id: res.id })
        }
        const farmInspectionCropData = await api.post('/FarmInspectionTab/farmInspectionCropData', { data: { cropData: cropData } })

        const inspection = getState().get('farmInspection').get('data');
        inspectionList = inspection.data.farm_inspection_data;
        inspectionList.splice(0, 0, {
          farm_id: data.farm_id,
          id: res.id,
          farm_inspection_crop_data: farmInspectionCropData
        });
        data.farm_inspection_data = Object.assign([], inspectionList);
        dispatch({ type: LOAD_DATA_SUCCESS, result: { data: Object.assign({}, data) } });
        resolve(inspectionList);
      });
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
});

export const addFarmImprovement = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  let FarmImprovment = getState().get('farmInspection').get('FarmImprovment');
  try {
    const res = await api.post('/FarmInspectionTab/addImprovment', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message })
    }
    FarmImprovment.push(res);
    dispatch({ type: FARMIMPROVMENT_LOAD_ADD_SUCCESS, result: Object.assign([], FarmImprovment) });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
}

export const getPrintInspectionsLetter = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/FarmInspectionTab/printInspectionLetterById', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FARM_INSPECTION_PRINT_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const generateInspectionReport = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.post('/FarmInspectionTab/printInspectionReportById', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: FARM_INSPECTION_PRINT_SUCCESS });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
};

export const updateInspectionData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.put('/FarmInspectionTab/inspection', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message });
      return;
    }
    dispatch({ type: INSPECTION_UPDATE_SUCCESS, result: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error.message || error });
  }
};

/**
 * Adding Farm Improvement Inspection List
 * @param {name, type} data
 * @returns saved Imp list
 */
export const addFarmImproveInspList = (data) => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  // let FarmImprovment = getState().get('farmInspection').get('FarmImprovment');
  try {
    const res = await api.post('/FarmInspectionTab/add-improvement-inspection-name', { data });
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message })
    }
    dispatch({ type: FARM_IMP_INSP_LIST_SUCCESS, farmImpList: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
}

/**
 * Getting Farm Improvement Inspection List
 * @param {name, type} data
 * @returns saved Imp list
 */
export const getImprovementList = () => async (dispatch, _getState, api) => {
  dispatch({ type: LOAD });
  try {
    const res = await api.get('/FarmInspectionTab/get-improvement-list');
    if (res.message) {
      dispatch({ type: LOAD_FAIL, errorMessage: res.message })
    }
    dispatch({ type: FARM_IMP_INSP_LIST_SUCCESS, farmImpList: res });
    return res;
  } catch (error) {
    dispatch({ type: LOAD_FAIL, errorMessage: error });
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/farmInspection.js